import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaTimePickerComponent from './VaTimePicker.vue'

export const VaTimePicker = withConfigTransport(VaTimePickerComponent) as typeof VaTimePickerComponent
